var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9DCA33F1-416A-4835-A31D-664987936661") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "system-notification",
    transform: "translate(-558.000000, -216.000000)",
    fill: "#ffd110",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(557.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-settings-20px-copy-2",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.15625,16.4625 C26.2125,15.99375 26.25,15.50625 26.25,15 C26.25,14.49375 26.2125,14.00625 26.1375,13.5375 L29.30625,11.0625 C29.5875,10.8375 29.6625,10.425 29.49375,10.10625 L26.49375,4.9125 C26.30625,4.575 25.9125,4.4625 25.575,4.575 L21.84375,6.075 C21.05625,5.475 20.23125,4.9875 19.3125,4.6125 L18.75,0.6375 C18.69375,0.2625 18.375,0 18,0 L12,0 C11.625,0 11.325,0.2625 11.26875,0.6375 L10.70625,4.6125 C9.7875,4.9875 8.94375,5.49375 8.175,6.075 L4.44375,4.575 C4.10625,4.44375 3.7125,4.575 3.525,4.9125 L0.525,10.10625 C0.3375,10.44375 0.4125,10.8375 0.7125,11.0625 L3.88125,13.5375 C3.80625,14.00625 3.75,14.5125 3.75,15 C3.75,15.4875 3.7875,15.99375 3.8625,16.4625 L0.69375,18.9375 C0.4125,19.1625 0.3375,19.575 0.50625,19.89375 L3.50625,25.0875 C3.69375,25.425 4.0875,25.5375 4.425,25.425 L8.15625,23.925 C8.94375,24.525 9.76875,25.0125 10.6875,25.3875 L11.25,29.3625 C11.325,29.7375 11.625,30 12,30 L18,30 C18.375,30 18.69375,29.7375 18.73125,29.3625 L19.29375,25.3875 C20.2125,25.0125 21.05625,24.50625 21.825,23.925 L25.55625,25.425 C25.89375,25.55625 26.2875,25.425 26.475,25.0875 L29.475,19.89375 C29.6625,19.55625 29.5875,19.1625 29.2875,18.9375 L26.15625,16.4625 L26.15625,16.4625 Z M15,20.625 C11.90625,20.625 9.375,18.09375 9.375,15 C9.375,11.90625 11.90625,9.375 15,9.375 C18.09375,9.375 20.625,11.90625 20.625,15 C20.625,18.09375 18.09375,20.625 15,20.625 Z",
    id: "Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/setting-icon.7ebf736aa7c84650430abc54176f4ead.svg";